import classNames from 'classnames';
import Masonry2x2Card, { Masonry2x2CardData } from './Masonry2x2Card';
import styles from './masonry2x2.module.scss';
import React from 'react';

export const Masonry2x2 = (props: {
  className?: classNames.Argument | classNames.ArgumentArray;
  cardsData: Masonry2x2CardData[];
}) => {
  return (
    <div className={classNames(styles.masonry2x2Block, props.className)}>
      {props.cardsData.map((card, i) => (
        <Masonry2x2Card key={i} card={card} />
      ))}
    </div>
  );
};
